export default {
  blf: [
    {
      name: 'Chronic obstructive pulmonary disease',
      slug: 'chronic-obstructive-pulmonary-disease-copd',
    },
    {
      name: 'Bronchitis',
      slug: 'bronchitis',
    },
    {
      name: 'Respiratory tract infection',
      slug: 'respiratory-tract-infection',
    },
  ],
  'copd-friends': [
    {
      name: 'Chronic obstructive pulmonary disease',
      slug: 'chronic-obstructive-pulmonary-disease-copd',
    },
    {
      name: 'Bronchitis',
      slug: 'bronchitis',
    },
    {
      name: 'Respiratory tract infection',
      slug: 'respiratory-tract-infection',
    },
  ],
  lupusuk: [
    {
      name: 'Lupus',
      slug: 'lupus',
    },
  ],
  'lupus-support': [
    {
      name: 'Lupus',
      slug: 'lupus',
    },
  ],
  'anxiety-depression-support': [
    {
      name: 'Anxiety',
      slug: 'anxiety',
    },
    {
      name: 'Bipolar disorder',
      slug: 'bipolar-disorder',
    },
    {
      name: 'Clinical depression',
      slug: 'clinical-depression',
    },
  ],
  anxietysupport: [
    {
      name: 'Anxiety',
      slug: 'anxiety',
    },
  ],
  'breastcancer-haven': [
    {
      name: 'Breast cancer',
      slug: 'breast-cancer',
    },
  ],
  'share-breast-cancer-support': [
    {
      name: 'Breast cancer',
      slug: 'breast-cancer',
    },
  ],
  'mental-health-support': [
    {
      name: 'Bipolar disorder',
      slug: 'bipolar-disorder',
    },
    {
      name: 'Clinical depression',
      slug: 'clinical-depression',
    },
  ],
  thyroiduk: [
    {
      name: 'Underactive thyroid hypothyroidism',
      slug: 'underactive-thyroid-hypothyroidism',
    },
  ],
  healmyptsd: [
    {
      name: 'Post traumatic stress disorder',
      slug: 'post-traumatic-stress-disorder-ptsd',
    },
  ],
  nkfearlyckd: [
    {
      name: 'Chronic kidney disease',
      slug: 'ckd',
    },
  ],
  'nkf-ckd': [
    {
      name: 'Chronic kidney disease',
      slug: 'ckd',
    },
  ],
  asthmauk: [
    {
      name: 'Asthma',
      slug: 'asthma',
    },
  ],
  usasthma: [
    {
      name: 'Asthma',
      slug: 'asthma',
    },
  ],
  lungcancer: [
    {
      name: 'Lung cancer',
      slug: 'lung-cancer',
    },
  ],
  freetobreathe: [
    {
      name: 'Lung cancer',
      slug: 'lung-cancer',
    },
  ],
  ovacome: [
    {
      name: 'Ovarian cancer',
      slug: 'ovarian-cancer',
    },
  ],
  'share-ovarian-cancer-support': [
    {
      name: 'Ovarian cancer',
      slug: 'ovarian-cancer',
    },
  ],
  ovacare: [
    {
      name: 'Ovarian cancer',
      slug: 'ovarian-cancer',
    },
  ],
  drwfdiabetes: [
    {
      name: 'Leukaemia',
      slug: 'leukaemia',
    },
  ],
  'leukaemia-care': [
    {
      name: 'Leukaemia',
      slug: 'leukaemia',
    },
  ],
  'endometriosis-uk': [
    {
      name: 'Endometriosis',
      slug: 'endometriosis',
    },
  ],
  'sleep-support': [
    {
      name: 'Insomnia',
      slug: 'insomnia',
    },
  ],
};
